import { useEffect } from 'react'
import { CalculatorIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { SalesEngagementContent } from '../pages/SalesEngagementPage'

interface Props {
  open: boolean
  onClose: () => void
}

export default function RoiCalculatorModal({ open, onClose }: Props) {
  useEffect(() => {
    if (!open) return
    const handleKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/40 p-4 pt-[2vh]"
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
      <div
        className="relative flex w-full max-w-7xl flex-col rounded-xl bg-gray-50 shadow-2xl ring-1 ring-gray-200"
        style={{ height: '96vh' }}
        role="dialog"
        aria-modal="true"
        aria-label="ROI Calculator"
      >
        <div className="flex flex-shrink-0 items-center justify-between rounded-t-xl border-b border-gray-200 bg-white px-6 py-3">
          <div className="flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50">
              <CalculatorIcon className="h-4 w-4 text-blue-600" />
            </div>
            <span className="text-sm font-semibold text-gray-900">AMB Cost Savings Calculator</span>
            <span className="ml-1 rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-bold text-blue-700 ring-1 ring-blue-100">
              Messaging Advisory
            </span>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close calculator"
            className="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-6">
          <SalesEngagementContent onClose={onClose} />
        </div>
      </div>
    </div>
  )
}
